import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoalHttpService {
  
  constructor(private http: HttpClient) {}

  /**
   * Busca dados da meta ativa por hashGoal
   */
  getGoalByHash(hashGoal: string): Observable<any> {
    return this.http.get(`${environment.backend}/goals/widget/${hashGoal}`);
  }

  /**
   * Busca configurações de alerta por hashGoal  
   */
  getAlertSettingsByHash(hashGoal: string): Observable<any> {
    return this.http.get(`${environment.backend}/streamer-alert-settings/by-hash/${hashGoal}?alertType=GOAL`);
  }
}